<template>
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex>
                <h2 class="pr-3">{{ $t('menu.team_list') }}</h2>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="invitation_items.length">
            <v-flex sm12>
                <v-badge overlap color="red" right>
                    <span slot="badge">{{invitation_items.length}}</span>
                    <v-btn color="info" @click="openInvitationDialog()">{{$t('team.waiting_to_accept')}}</v-btn>
                </v-badge>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <template v-for="(item, i) in items">
                <v-flex
                    xs12 sm6 md4
                    :key="i"
                >
                    <v-card style="cursor: pointer;">
                        <v-card-title class="pa-0" primary-title>
                            <v-flex xs3>
                                <v-icon x-large>fas fa-user-friends</v-icon>
                            </v-flex>
                            <v-flex xs6>
                                <div>
                                    <div class="font-weight-bold">{{item.name}}</div>
                                    <div>{{getTeamRole(item)}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs3 class="text-xs-right">
                                <v-menu v-model="item.showMenu" bottom left>
                                    <v-btn
                                        slot="activator"
                                        icon
                                    >
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>

                                    <v-list>
                                        <template v-if="isTeamOwner(item)">
                                            <v-list-tile
                                                    @click="editItem(item)"
                                            >
                                                <v-list-tile-title>{{$t('action.edit')}}</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                    @click="deleteItem(item)"
                                            >
                                                <v-list-tile-title>{{$t('action.delete')}}</v-list-tile-title>
                                            </v-list-tile>
                                        </template>
                                        <template v-else>
                                            <v-list-tile
                                                    @click="leaveTeam(item)"
                                            >
                                                <v-list-tile-title>{{$t('action.leave_team')}}</v-list-tile-title>
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                        </v-card-title>
                    </v-card>

                </v-flex>
            </template>
            <v-btn
                color="primary"
                dark
                fab
                fixed
                bottom
                right
                @click="showNewForm"
                class="mb-5"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-layout>

        <div class="text-xs-center">
            <v-progress-circular v-show="loading" color="grey" :indeterminate="true">
            </v-progress-circular>
        </div>

        <team-edit-dialog
            v-model="editForm.show"
            :item="editForm.item"
            @success="editSuccess"
            @kick_success="kickSuccess"
            @remove_invitation_success="removeInvitationSuccess"
            @add_invitation_success="addInvitationSuccess"
        ></team-edit-dialog>

        <v-dialog v-model="join_team_dialog.show" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar dark color="primary" height="80">
                    <v-toolbar-title>{{$t('team.team_invitations')}}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="join_team_dialog.show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider />
                <v-card-text class="v-dialog-body">
                    <v-container grid-list-md>
                        <h3>{{$t('team.team_information')}}</h3>
                        <v-list two-line class="pa-0 my-1 elevation-1">
                            <v-list-tile v-if="join_team_dialog.team_item">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{join_team_dialog.team_item.name}}</v-list-tile-title>
                                    <v-list-tile-sub-title><v-icon size="16">person</v-icon> {{join_team_dialog.team_item.creator}}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action class="invitation-actions">
                                    <v-btn fab dark small color="success" @click="joinTeam" :loading="join_team_dialog.loading">
                                        <v-icon dark>done</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="invitation_items_dialog.show" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar dark color="primary" height="80">
                    <v-toolbar-title>{{$t('team.team_invitations')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeInvitationDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="v-dialog-body">
                    <v-container grid-list-md>
                        <h3>{{$t('team.waiting_to_accept')}}:</h3>
                        <div v-if="invitation_items.length">
                            <v-list two-line class="pa-0 my-1 elevation-1">
                                <template v-for="invitation_item in invitation_items">
                                    <v-list-tile
                                        :key="invitation_item.id"
                                    >
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{invitation_item.team_name}}</v-list-tile-title>
                                            <v-list-tile-sub-title><strong>{{$t('team.invited_by')}}:</strong> {{invitation_item.inviter_email}}</v-list-tile-sub-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action class="invitation-actions">
                                            <v-btn fab dark small color="success" class="mr-2" @click="acceptInvitation(invitation_item)" :disabled="invitation_item.disabled" :loading="invitation_item.accept_loading">
                                                <v-icon dark>done</v-icon>
                                            </v-btn>
                                            <v-btn fab dark small color="error" @click="rejectInvitation(invitation_item)" :disabled="invitation_item.disabled" :loading="invitation_item.reject_loading">
                                                <v-icon dark>clear</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </div>

                        <v-alert
                            v-else
                            :value="true"
                            type="info"
                        >
                            {{$t('general.no_record_found')}}
                        </v-alert>

                        <v-layout row wrap>

                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>
    import i18n from "~/i18n";
    import {UrlServices} from "~/utils/url-manager";
    import {CancelToken} from "axios";
    import RequestHandler from "~/utils/request-handler";
    import formatter from "~/utils/formatter";
    import TeamEditDialog from "~/components/team/TeamEditDialog";

    export default {
        components: {
            TeamEditDialog
        },
        data() {
            return {
                loading: false,
                bottomReached: false,
                page: 1,
                items: [],
                invitation_items: [],
                invitation_items_dialog: {
                    show: false
                },
                join_team_dialog: {
                    show: false,
                    team_item: null,
                    key: null,
                    loading: false
                },
                actions: [i18n.t('action.edit'), i18n.t('action.delete')],
                editForm: {
                    action: UrlServices.createUrl({'name': 'api_team_save'}),
                    show: false,
                    item: {
                        name: '',
                        members: [],
                        invited_users: []
                    },
                    errors: {
                        name: ''
                    }
                },
                search: '',
                searching: false,
                cancel: () => {}
            };
        },
        methods: {
            reload() {
                this.page = 1;
                this.items = [];
                this.bottomReached = false;
                this.getTeams();
            },
            isTeamOwner(item) {
                let user_id = getApp.$store.state.user_info.id;
                return user_id == item.creator_id;
            },
            getTeamRole(item) {
                if(this.isTeamOwner(item)){
                    return this.$t('team.team_admin');
                } else {
                    return this.$t('team.team_member');
                }
            },
            getTeams(search) {
                let me = this;
                me.loading = true;
                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        me.cancel = c;
                    })
                };
                let params = {
                    page: me.page,
                    search: search
                };
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_team_list'}), params, {
                    'success': function (data) {
                        _.each(data.team_list.data, x => {
                            x.showMenu = false;
                            me.items.push(x);
                        });

                        _.each(data.invitation_list, x => {
                            x.accept_loading = false;
                            x.reject_loading = false;
                            me.invitation_items.push(x);
                        });

                        me.loading = false;
                        me.searching = false;
                        if(me.page < data.team_list.total_page) {
                            me.bottomReached = false;
                        }
                        me.page++;

                        let show_invitation_dialog = me.$route.query.show_invitation_dialog;
                        if(show_invitation_dialog==1 && me.invitation_items.length){
                            me.invitation_items_dialog.show = true;
                        }
                    }
                }, config);
            },
            showNewForm() {
                this.editForm.item = {
                    name: '',
                    members: [],
                    invited_users: []
                };
                this.editForm.show = true;
            },
            editItem(item) {
                item.showMenu = false;
                this.editForm.item = _.extend({}, item);
                this.editForm.show = true;
            },
            editSuccess(data) {
                let item = _.find(this.items, x => {
                    return x.id === data.id;
                });

                let is_new_item;

                if(item) {
                    is_new_item = false;
                    item.name = data.name;
                } else {
                    is_new_item = true;
                    item = data;
                    item.showMenu = false;
                    this.items.push(item);
                }

                getApp.$emit("UPDATE_AVAILABLE_TEAM");

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: is_new_item ? this.$t('app.msg_create_success') : this.$t('app.msg_edit_success'),
                    timeout: 3000
                };
            },
            kickSuccess(result) {

                let current_edit_item = this.editForm.item;

                let item = _.find(this.items, x => {
                    return x.id === result.team_id;
                });

                item.members = _.filter(item.members, x => {
                    return x.id !== result.user_id;
                });
                current_edit_item.members = _.filter(current_edit_item.members, x => {
                    return x.id !== result.user_id;
                });
            },
            removeInvitationSuccess(result) {
                let current_edit_item = this.editForm.item;

                let item = _.find(this.items, x => {
                    return x.id === result.team_id;
                });

                item.invited_users = _.filter(item.invited_users, x => {
                    return x.id !== result.invitation_id;
                });
                current_edit_item.invited_users = _.filter(current_edit_item.invited_users, x => {
                    return x.id !== result.invitation_id;
                });
            },
            addInvitationSuccess(data) {
                let current_edit_item = this.editForm.item;
                current_edit_item.invited_users.push(data);
            },
            deleteItem(item) {
                let me = this;
                this.$root.$confirm(
                    this.$t('team.delete_team'),
                    this.$t('team.delete_team_msg', {
                        'team_name': item.name
                    })).then((confirm) => {
                    if(confirm){
                        RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_delete'}), {
                            id: item.id
                        }, {
                            'success': function(data) {
                                me.items = _.filter(me.items, x => {
                                    return x.id !== item.id;
                                });
                                getApp.snackbar = {
                                    show: true,
                                    color: 'green',
                                    text: data.msg,
                                    timeout: 3000
                                };
                                getApp.$emit("UPDATE_AVAILABLE_TEAM");
                            },
                            'error': function(data) {
                                getApp.snackbar = {
                                    show: true,
                                    color: 'red',
                                    text: data.msg,
                                    timeout: 3000
                                };
                            }
                        });
                    }
                })
            },
            leaveTeam(item) {
                let me = this;
                this.$root.$confirm(
                    this.$t('team.leave_team'),
                    this.$t('team.leave_team_msg', {
                        'team_name': item.name
                    })).then((confirm) => {
                    if(confirm){
                        RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_leave'}), {
                            id: item.id
                        }, {
                            'success': function(data) {
                                me.items = _.filter(me.items, x => {
                                    return x.id !== item.id;
                                });
                                getApp.snackbar = {
                                    show: true,
                                    color: 'green',
                                    text: data.msg,
                                    timeout: 3000
                                };
                                getApp.$emit("UPDATE_AVAILABLE_TEAM");
                            },
                            'error': function(data) {
                                getApp.snackbar = {
                                    show: true,
                                    color: 'red',
                                    text: data.msg,
                                    timeout: 3000
                                };
                            }
                        });
                    }
                })
            },
            onScroll() {
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.getTeams();
                    }
                }
            },
            openInvitationDialog() {
                this.invitation_items_dialog.show = true;
            },
            closeInvitationDialog() {
                this.invitation_items_dialog.show = false;
            },
            acceptInvitation(item) {
                let me = this;

                item.accept_loading = true;

                RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_invitation_accept'}), {
                    invitation_id: item.id
                }, {
                    'success': function (data) {

                        me.invitation_items = _.filter(me.invitation_items, x => {
                            return x.id !== item.id;
                        });

                        me.items.push(data.team_data);

                        getApp.$emit("UPDATE_AVAILABLE_TEAM");

                        getApp.snackbar = {
                            show: true,
                            color: 'green',
                            text: data.msg,
                            timeout: 3000
                        };
                    },
                    'error': function (data) {
                        item.accept_loading = false;
                        getApp.snackbar = {
                            show: true,
                            color: 'red',
                            text: data.msg,
                            timeout: 3000
                        };
                    }
                });
            },
            rejectInvitation(item) {
                let me = this;
                item.reject_loading = true;

                RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_invitation_reject'}), {
                    invitation_id: item.id
                }, {
                    'success': function (data) {

                        me.invitation_items = _.filter(me.invitation_items, x => {
                            return x.id !== item.id;
                        });

                        getApp.snackbar = {
                            show: true,
                            color: 'green',
                            text: data.msg,
                            timeout: 3000
                        };
                    },
                    'error': function (data) {
                        item.reject_loading = false;
                        getApp.snackbar = {
                            show: true,
                            color: 'red',
                            text: data.msg,
                            timeout: 3000
                        };
                    }
                });
            },
            processJoinTeam(encrypted_team_id) {
                let me = this;
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_team_invitation_get_by_key'}), {
                    key: encrypted_team_id
                }, {
                    'success': function (data) {
                        me.join_team_dialog.team_item = data;
                        me.join_team_dialog.show = true;
                        me.join_team_dialog.key = encrypted_team_id;
                    }
                });
            },
            joinTeam() {
                let me = this;

                me.join_team_dialog.loading = true;

                RequestHandler.Post(UrlServices.createUrl({'name': 'api_team_invitation_accept_by_key'}), {
                    key: me.join_team_dialog.key
                }, {
                    'success': function(data) {
                        me.items.push(data.team_data);

                        getApp.$emit("UPDATE_AVAILABLE_TEAM");

                        getApp.snackbar = {
                            show: true,
                            color: 'green',
                            text: data.msg,
                            timeout: 3000
                        };

                        me.join_team_dialog.show = false;
                        me.join_team_dialog.loading = false;
                    },
                    'error': function(data) {
                        me.join_team_dialog.loading = false;
                        getApp.snackbar = {
                            show: true,
                            color: 'red',
                            text: data.msg,
                            timeout: 3000
                        };
                    }
                });
            }
        },
        mounted() {
            this.getTeams();

            let encrypted_team_id = this.$route.query.join_team_key;
            if(encrypted_team_id){
                this.processJoinTeam(encrypted_team_id);
            }
        }
    }
</script>

<style scoped>
    .invitation-actions {
        flex-direction: row;
    }
</style>
